import type { Translations } from '@/types';

export const en: Translations = {
  'app.title': 'Firewall Block Page Simulator',
  'app.subtitle': 'Training & Educational Platform',
  'app.disclaimer': 'This is a simulated firewall block page for training purposes only. No actual security policy violation has occurred.',
  
  'nav.generator': 'Generator',
  'nav.dashboard': 'Analytics',
  'nav.settings': 'Settings',
  'nav.help': 'Help',
  
  'config.basicInfo': 'Basic Information',
  'config.blockedUrl': 'Blocked URL',
  'config.category': 'Category',
  'config.firewallMode': 'Firewall Mode',
  'config.organization': 'Organization Name',
  
  'config.networkDetails': 'Network Details',
  'config.firewallName': 'Firewall Name',
  'config.ipAddress': 'Client IP Address',
  'config.userName': 'Username (Optional)',
  
  'config.errorInfo': 'Error Information',
  'config.errorCode': 'Error Code',
  'config.blockType': 'Block Type',
  
  'config.adminContact': 'Administrator Contact',
  'config.adminEmail': 'Admin Email',
  'config.adminPhone': 'Admin Phone',
  'config.adminPortal': 'Admin Portal URL',
  
  'config.technicalDetails': 'Technical Details',
  'config.policyId': 'Policy ID',
  'config.firewallSerial': 'Firewall Serial Number',
  'config.threatId': 'Threat ID',
  'config.webFilterProfile': 'Web Filter Profile',
  'config.securityProfile': 'Security Profile',
  'config.sslInspection': 'SSL Inspection',
  'config.actionTaken': 'Action Taken',
  'config.destinationIp': 'Destination IP',
  'config.destinationPort': 'Destination Port',
  'config.protocol': 'Protocol',
  'config.sessionId': 'Session ID',
  
  'config.displayOptions': 'Display Options',
  'config.showDisclaimer': 'Show Training Disclaimer',
  'config.showTechnicalDetails': 'Show Technical Details',
  'config.showRequestAccess': 'Show Request Access Button',
  'config.theme': 'Theme',
  'config.language': 'Language',
  
  'scenarios.title': 'Scenario Presets',
  'scenarios.malware': 'Malware Distribution Site',
  'scenarios.phishing': 'Phishing Attempt',
  'scenarios.adultContent': 'Adult Content Block',
  'scenarios.gaming': 'Gaming Website Block',
  'scenarios.geoBlock': 'Geo-Blocked Region',
  'scenarios.socialMedia': 'Social Media Block',
  'scenarios.streaming': 'Streaming Media Block',
  
  'export.title': 'Export Options',
  'export.html': 'Export as HTML',
  'export.zip': 'Download ZIP Package',
  'export.json': 'Export Config (JSON)',
  'export.copy': 'Copy HTML to Clipboard',
  'export.screenshot': 'Generate Screenshot',
  
  'preview.title': 'Preview',
  'preview.live': 'Live Preview',
  
  'requestAccess.title': 'Request Access',
  'requestAccess.name': 'Your Name',
  'requestAccess.email': 'Your Email',
  'requestAccess.reason': 'Reason for Access',
  'requestAccess.submit': 'Submit Request',
  'requestAccess.success': 'Request submitted successfully!',
  'requestAccess.ticketId': 'Your ticket ID:',
  
  'training.title': 'Training Mode',
  'training.enable': 'Enable Training Mode',
  'training.tooltip.webFilter': 'Web filtering blocks access to websites based on their content category. This helps organizations enforce acceptable use policies.',
  'training.tooltip.category': 'Content categories classify websites by their primary purpose. Categories like Malware, Phishing, and Adult Content are commonly blocked in corporate environments.',
  'training.tooltip.sslInspection': 'SSL inspection decrypts and analyzes encrypted HTTPS traffic to detect threats that may be hidden in secure connections.',
  'training.tooltip.policy': 'Security policies define what traffic is allowed or blocked based on various criteria including user, group, time, and content category.',
  
  'dashboard.title': 'Analytics Dashboard',
  'dashboard.totalBlocks': 'Total Blocked Attempts',
  'dashboard.topCategories': 'Top Blocked Categories',
  'dashboard.timeline': 'Block Timeline',
  
  'common.save': 'Save',
  'common.load': 'Load',
  'common.reset': 'Reset',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.generate': 'Generate',
  'common.export': 'Export',
  'common.copy': 'Copy',
  'common.copied': 'Copied!',
  'common.error': 'Error',
  'common.success': 'Success',
};
